/**
 * Statusi gost-narudžbi: redosled u meniju, boje i šta se računa kao "aktivna" narudžba.
 * Isti izvor koristi stari izveštaj (hasGuestOrderStatus) i novi izgled (guest-report).
 */
// zamrznuto: koristi se u data() više komponenti, Vue ga ne treba da posmatra
export const ORDER_STATUSES = Object.freeze(
  [
    { value: "pending", icon: "mdi-clock-outline" },
    { value: "accepted", icon: "mdi-check" },
    { value: "in-progress", icon: "mdi-progress-clock" },
    { value: "ready", icon: "mdi-food" },
    { value: "on-hold", icon: "mdi-pause" },
    { value: "delivered", icon: "mdi-truck-check" },
    { value: "completed", icon: "mdi-check-all" },
    // "cancelled": otkazao kupac; "rejected": odbio restoran
    { value: "cancelled", icon: "mdi-cancel" },
    { value: "rejected", icon: "mdi-close-circle-outline" },
  ].map((status) => Object.freeze(status))
);

export const STATUS_COLORS = {
  pending: { fg: "#92620a", bg: "#fbeed2" },
  accepted: { fg: "#1d4ed8", bg: "#e3ebfc" },
  "in-progress": { fg: "#0e7c86", bg: "#ddf3f4" },
  ready: { fg: "#6d28d9", bg: "#eee4fb" },
  // isti prevod na srpskom ("Na čekanju") kao "pending", pa ista boja radi doslednosti
  "on-hold": { fg: "#92620a", bg: "#fbeed2" },
  delivered: { fg: "#157f3c", bg: "#e0f5e6" },
  completed: { fg: "#157f3c", bg: "#e0f5e6" },
  cancelled: { fg: "#b42318", bg: "#fae3e1" },
  "support-canceled": { fg: "#b42318", bg: "#fae3e1" },
  rejected: { fg: "#b42318", bg: "#fae3e1" },
  deleted: { fg: "#b42318", bg: "#fae3e1" },
};

const FALLBACK_COLORS = { fg: "#55606b", bg: "#eaecee" };

export const getStatusColors = (status) => STATUS_COLORS[status] || FALLBACK_COLORS;

/** Vrste isporuke narudžbe (delivery_type) */
export const DELIVERY_TYPES = Object.freeze(
  [
    { id: 0, key: "home_delivery", icon: "mdi-moped-outline" },
    { id: 1, key: "pickup_at_restaurant", icon: "mdi-storefront-outline" },
    { id: 2, key: "dine_in_restaurant", icon: "mdi-silverware-fork-knife" },
    { id: 5, key: "express_mail", icon: "mdi-email-fast-outline" },
  ].map((type) => Object.freeze(type))
);

/** Završeno ili otkazano: narudžba više ne čeka restoran. */
const CLOSED_STATES = ["delivered", "completed", "cancelled", "support-canceled", "rejected", "deleted"];

export const isActiveState = (state) => !CLOSED_STATES.includes(state);

/** Backend za otkazanu narudžbu vraća "support-canceled"; u menijima je to "cancelled". */
export const menuState = (state) => (state === "support-canceled" ? "cancelled" : state);
